
import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styled from "styled-components";
const CustomCheckBoxForCards = ({checked, onChange, size = 'xs'}) => {
    if (checked === true)
        return (
            <CheckBoxContainer className="d-flex justify-content-center align-items-center">
                <FontAwesomeIcon size={size} icon='check' onClick={onChange}/>
            </CheckBoxContainer>
        )
    else
        return (<CheckBoxContainer onClick={() => onChange()}/>)
}

export default CustomCheckBoxForCards;

const CheckBoxContainer = styled.div`
    width: 20px;
    height: 20px;
    border: 2px solid hsl(0, 0%, 50%);
    cursor: pointer;
    
    transition: all 0.3s ease-in-out;
    user-select: none;
    margin-top: 2px;
`;